import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "next-i18next";
import { useWidth } from "@/utils/resize";
import { getPrices } from "@/service/index";
import buriedsdk from "@/utils/zz-buried/index";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css";
import { Pagination } from "swiper";

import yes from "@images/pricng/check.png";
import no from "@images/pricng/no.png";
import most from "@images/pricng/most.png";

type Props = {
  cycleUnit: string;
  list: any[];
  isLogin: boolean
};

const Index = (props: Props) => {
  const { cycleUnit, list, isLogin } = props;
  const { width, display } = useWidth();
  const { t, i18n } = useTranslation("pricing");

  const calcPrice = (val: number) => {
    if (props.cycleUnit === "y") return (val / 12).toFixed(0);
    else return val;
  };

  const toCheckout = (name) => {
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `价格页-${name}套餐-Get Started按钮`,
      URL: process.env.publicApiDomain,
    });
  };

  return (
    <div>
      <div className={styles.wrap + " defeaultContainer"}>
        <Swiper
          spaceBetween={12}
          slidesPerView={"auto"}
          modules={[Pagination]}
          style={{ paddingBottom: "1.36rem" }}
          pagination={{
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
            bulletClass: ` ${styles.myBullet} swiper-pagination-bullet`,
            bulletActiveClass: `${styles.myActiveBullet} swiper-pagination-bullet-active`,
          }}
        >
          {list.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className={`${styles.item} ${
                  index === 1 ? styles.itemMost : ""
                }`}
              >
                {index === 1 && (
                  <div className={styles.most}>
                    <Image src={most} width={101} height={94}></Image>
                  </div>
                )}
                <h3 className={styles.name}>{item.comboName}</h3>
                <div className={styles.price}>
                  ${calcPrice(item[`${props.cycleUnit}Price`])}{" "}
                  <span>/ {t("Month")}</span>
                </div>
                <p className={styles.desc}>{item.desc}</p>
                <a
                  className={styles.started}
                  href={isLogin ? '/checkout' : '/login?fromPath=/checkout'}
                  onClick={() => toCheckout(item.comboName)}
                >
                  {t("Get Started")}
                </a>
                {item.info.map((it, idx) => (
                  <div className=" w-full flex items-center justify-start mt-[14px]" key={idx}>
                    <div
                      className={
                        (it.status ? "bg-[#68D287]" : "bg-[#FF5F3E]") +
                        " w-[18px] h-[18px] flex justify-center items-center rounded-[50%] mr-[16px]"
                      }
                    >
                      <Image
                        src={it.status ? yes : no}
                        width={14}
                        height={14}
                      ></Image>
                    </div>
                    <div className={styles.tips}>
                      <p key={idx}>
                        {idx === 2 && (
                          <span className="mr-[5px] font-[600]">
                            {t(it.hard)}
                          </span>
                        )}
                        {t(it.tips)}
                        {idx !== 2 && (
                          <span className="ml-[5px] font-[600]">
                            {t(it.hard)}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                ))}
                <div
                  className={`swiper-pagination ${styles.myPagination}`}
                ></div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
export default Index;
